export function sanitizeDecimalInput(value: string): string {
  const sanitizedValue = value.replace(/[^0-9.,]/g, "");
  let hasDecimalSeparator = false;
  let result = "";

  for (const char of sanitizedValue) {
    if (char === "." || char === ",") {
      if (hasDecimalSeparator) {
        continue;
      }
      hasDecimalSeparator = true;
    }

    result += char;
  }

  return result;
}

export function parseDecimalNumber(value: unknown): number | undefined {
  if (value == null || value === "") return undefined;

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : undefined;
  }

  if (typeof value !== "string") return undefined;

  const normalizedValue = value.trim().replace(/,/g, ".");
  if (normalizedValue === "" || normalizedValue === ".") {
    return undefined;
  }

  const parsedValue = Number(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : undefined;
}
